import ContentLoader from 'react-content-loader';

interface Props {
    height: number;
    radius?: number;
    width?: number;
}

const LoaderElement = ({ height, radius = 0, width }: Props): JSX.Element => (
    <ContentLoader
        speed={2}
        width={width ? width : '100%'}
        height={height}
        backgroundColor="#d8d8d8"
        foregroundColor="#e5e5e5"
    >
        <rect x="0" y="0" rx={radius} width="100%" height={height} />
    </ContentLoader>
);

export default LoaderElement;
